import React, { ReactNode, useState } from 'react';
import styles from './universal-dropdown-selector.module.scss';
import { RoundTriangle } from '../triangle/round-triangle';

interface IUniversalDropdownSelectorProps {
  title: string;
  options?: ReactNode;
  selectedOption: ReactNode;
  onClick?: () => void;
  closeByClick?: boolean;
  defaultOpen?: boolean;
}

export const UniversalDropdownSelector: React.FC<
  IUniversalDropdownSelectorProps
> = ({
  title = 'Заголовок',
  options,
  selectedOption,
  onClick,
  closeByClick = true,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const clickHandler = (from?: string) => {
    setIsOpen((_isOpen) => {
      if (from == 'content' && !closeByClick) {
        return isOpen;
      }

      if (!_isOpen && onClick) {
        onClick();
      }
      return !_isOpen;
    });
  };
  return (
    <div className={styles.dropdown__container}>
      {options ? (
        <>
          <div
            className={styles.container__head}
            onClick={() => clickHandler()}
          >
            <div className={styles.head__title}>{title}</div>
            <RoundTriangle isRotated={isOpen} />
          </div>
          <div
            className={styles.container__content}
            onClick={() => {
              if (!isOpen) {
                clickHandler('content');
              }
            }}
          >
            {isOpen ? options : selectedOption}
          </div>
        </>
      ) : (
        <>
          <div
            className={`${styles.container__head} ${styles.container__head_disabled}`}
            onClick={() => clickHandler()}
          >
            <div className={styles.head__title}>{title}</div>
          </div>
          {selectedOption}
        </>
      )}
    </div>
  );
};
